import { AxiosPromise } from 'axios';
import FileDownload from 'js-file-download';

import { RfqExportRequest } from '../../common/api/clients/export.api';
import { extractFileName } from '../../common/helpers/extractFileName.helper';
import { translate } from '../../common/helpers/translate.helper';

import { useExportRfqMutation } from './useExportRfqMutation';

export const useRfqExport = (): { downloadPdf: (request: RfqExportRequest) => AxiosPromise<Blob> } => {
    const exportPdfMutation = useExportRfqMutation();

    const downloadPdf = async (request: RfqExportRequest) => {
        return exportPdfMutation.mutateAsync(request, {
            onSuccess: (response) => {
                FileDownload(
                    response.data,
                    extractFileName(
                        response.headers['content-disposition'] || '',
                        translate('attachments.fileNameFallback')
                    ),
                    'application/pdf'
                );
            },
        });
    };

    return {
        downloadPdf,
    };
};
